module.exports = __webpack_public_path__ + "static/img/product.bad4ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/product.png
// module id = PFr/
// module chunks = 0